export const HUB_ROUTES = {
    USER_PROFILE: {
        path: '/user/profile',
        name: 'user-profile',
    },
    REQUESTS_LIST: {
        path: '/user/requests',
        name: 'requests-list',
    },
    CSM_REQUESTS_LIST: {
        path: '/user/requests',
        name: 'csm-requests-list',
    },
    CSM_CONTACT_US: {
        path: '/contact-us/:requestId([0-9]+|[a-f0-9]{8}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{12})?',
        name: 'contact-us',
    },
};
